<script>
import TopNavbar from "@/layout/dashboard/TopNavbar.vue";
import {axiosApiInstance} from "@/axiosInterceptor";
import router from "@/router";
import ReferentForm from "@/components/ReferentForm.vue";

export default {
  name: 'referent-index',
  components: {
    TopNavbar,
    ReferentForm
  },
  data() {
    return {
      referent: {},
      flash: null,
    }
  },
  mounted() {
  },
  methods: {
    clearFlash() {
      this.flash = null
    },
    updateFlash(message, type) {
      this.flash = {message: message, type: type}
      setTimeout(() => {
        this.clearFlash()
      }, 3000)
    },
    returnToList(){
      router.push('/referent')
    },
    createNewReferent(){
      axiosApiInstance.post(process.env.VUE_APP_API_URL + '/referent/new', {referent: this.referent}).then(response => {
        if (response.data.created === true) {
          this.updateFlash('Le référent a été créé.', 'success')
          this.returnToList()
        }
      }).catch(() => {
        this.updateFlash("Une erreur est survenue.", 'danger')
      })
    }
  }
}

</script>

<template>
  <div class="wrapper">
    <div class="position-fixed top-0 start-50 translate-middle-x p-3" style="z-index: 11;padding-top:33px !important;">
      <div :class="'toast bg-' + flash.type + ' ' + (flash?'show':'hide')" v-if="flash">
        <div class="d-flex">
          <div class="toast-body">
            {{ flash.message }}
          </div>
          <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast"
                  aria-label="Fermer" @click="clearFlash"></button>
        </div>
      </div>
    </div>

    <side-bar>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>
      <div class="content">
        <h1>Nouveau référent</h1>
        <button class="btn btn-primary mb-5" @click="returnToList()">Retour à la liste</button>
        <ReferentForm :referent="referent" :persist="createNewReferent"/>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>